import { ActivityEntityName, ConfigurationSecurityRight, GeneralSetting, SurfaceType } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import { GeneralSettingService } from '@jms/ui/ui.standalone.services/general.setting.service';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

// General Settings: singleton Settings surface. No board, no create, no slug — finance-pro owns the page.

export const generalSettingsManifest = registerManifest<GeneralSetting>({
  entity: ActivityEntityName.GeneralSetting,
  identity: () => ({
    _id: 'current',
    name: 'General Settings',
    type: ActivityEntityName.GeneralSetting,
  }),
  routes: {
    root: '/finance-pro/general-settings',
  },
  surfaces: {
    [SurfaceType.Settings]: () => import('./surface/settings/general.settings.surface').then(module => module.generalSettingsSurface),
  },
  operations: {
    edit: {
      surface: SurfaceType.Settings,
      authorize: ({ injector }) => injector.get(RightsService).hasRights(ConfigurationSecurityRight.AccessTenancy),
      loadRecord: async ({ injector }) => injector.get(GeneralSettingService).load(),
    },
  },
});
